import styled, { css } from 'styled-components';
import { controllerTokens } from '../../../tokens/components/Controller/tokens';

const Affix = styled.div`
  background-color: ${controllerTokens.AffixBackgroundColorBaseDefault};
  border: 1px solid ${controllerTokens.ContainerBorderColorBaseDefault};
  border-radius: ${controllerTokens.ContainerBorderRadiusBaseDefault};
  flex-shrink: 0;
  height: 42px;
  line-height: 20px;
  padding: 10px 10px;

  ${({ theme }) =>
    theme.seam &&
    css`
      border-bottom-${theme.seam}-radius: 0;
      border-top-${theme.seam}-radius: 0;
      border-${theme.seam}-style: none;
    `}

  ${({ theme }) =>
    theme.controllerDisabled &&
    css`
      background-color: ${controllerTokens.ContainerBackgroundColorDisabledDefault};
      border-color: ${controllerTokens.ContainerBorderColorDisabledDefault};
      color: ${controllerTokens.ContainerFontColorDisabledDefault};
    `}
`;

export default Affix;
